exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#copy-rek {\r\n  font-size: 1.5em;\n}\n.tooltip.fade.top.in {\r\n  display: inline-block !important;\r\n  top: -15px !important;\r\n  left: 0 !important;\n}\r\n", ""]);

// exports
